export default {
    ja: {
        foods: {
            heading: 'FOODS',
            description: 'ネイキッドの飲食チームがプロデュースした、子どもも大人も楽しめる夏まつりグルメをラインナップ。 りんご飴や焼きそば、京都の老舗茶舗「福寿園」の抹茶や国産ゆずを贅沢に使用した、日本ならではの食材を楽しめる和風かき氷、生ビールやハイボールといったアルコールドリンクも充実！',
            readMore: '続きを読む',
            close: '閉じる',
            external: '公式サイト',
            items: [
                {
                    title: 'かき氷　京都抹茶',
                    subtitle: '',
                    description: '京都の老舗茶舗「福寿園」の高級抹茶を贅沢に使用した、自家製抹茶シロップをかけた京かき氷。抹茶の香りとてんさい糖の優しい甘さが口に広がります。本イベント限定のだるま最中を添えてご提供します。',
                    price: '販売価格：900円（税込）',
                    showTitle: true,
                    showSubtitle: false,
                    link: ''
                },
                {
                    title: 'かき氷　金沢ゆず',
                    subtitle: '',
                    description: '国産のゆずを使用した爽やかな和風かき氷。自家製シロップには有機栽培・規格外の熊本県産柑橘類も数種類使用。フードロス対策にもつながるサステナブルなかき氷。本イベント限定のだるま最中を添えてご提供します。',
                    price: '販売価格：900円（税込）',
                    showTitle: true,
                    showSubtitle: false,
                    link: ''
                },
                {
                    title: 'かき氷　熊本いちご',
                    subtitle: '',
                    description: '子どもにも大人気の、ごろっとした果肉がたっぷり入ったいちごシロップ。熊本県産の規格外いちごを活用し、フードロス対策にもなっています。本イベント限定のだるま最中を添えてご提供します。',
                    price: '販売価格：900円（税込）',
                    showTitle: true,
                    showSubtitle: false,
                    link: ''
                },
                {
                    title: 'ヴィーガン練乳風シロップ',
                    subtitle: '',
                    description: '豆乳をベースにアガベシロップ、ココナッツミルク、アーモンドミルク、コメ飴、てんさい糖を使用したヴィーガン仕様のオリジナル練乳。身体にも環境にも優しく、本物の練乳と変わらない甘さと美味しさです。',
                    price: '販売価格：＋150円（税込）',
                    showTitle: true,
                    showSubtitle: false,
                    link: ''
                },
                {
                    title: 'だるまりんご飴',
                    subtitle: '',
                    description: '本イベント限定のだるまパッケージに包まれた、夏まつりの定番スイーツ・りんご飴。キャンディコーティングのカリッとした食感と新鮮なりんごの甘みが口いっぱいに広がります。',
                    price: '販売価格：700円（税込）',
                    showTitle: true,
                    showSubtitle: false,
                    link: ''
                },
                {
                    title: 'たこ焼き串',
                    subtitle: '',
                    description: '夏まつりには欠かせない定番グルメのたこ焼き。片手でも食べやすい串付きタイプ。',
                    price: '販売価格：600円（税込）',
                    showTitle: true,
                    showSubtitle: false,
                    link: ''
                },
                {
                    title: 'フランクフルト',
                    subtitle: '',
                    description: '夏まつりには欠かせない定番グルメのフランクフルト。片手でも食べやすい串付きタイプ。',
                    price: '販売価格：500円（税込）',
                    showTitle: true,
                    showSubtitle: false,
                    link: ''
                },
                {
                    title: '国産ゆずレモネードソーダ',
                    subtitle: '',
                    description: '石川県産のゆず、熊本県産の有機レモンで日本らしさを感じられる自家製レモネードソーダ',
                    price: '販売価格：700円（税込）',
                    showTitle: true,
                    showSubtitle: false,
                    link: ''
                },
                {
                    title: '国産ゆずレモンハイボール',
                    subtitle: '',
                    description: '石川県産のゆず、熊本県産の有機レモンを使用したレモネードに、隠し味の梅をブレンドした日本らしいハイボール。自家製シロップの爽やかな酸味とウイスキーが相性抜群。',
                    price: '販売価格：800円（税込）',
                    showTitle: true,
                    showSubtitle: false,
                    link: ''
                },
                {
                    title: '国産ゆずレモンサワー',
                    subtitle: '',
                    description: '石川県産のゆず、熊本県産の有機レモンを使用したシロップに、隠し味の梅をブレンドした日本らしさを感じられるゆずレモンサワー。自家製シロップの爽やかな酸味にぴったりの、柑橘が香る芋焼酎『ナナクボブルー』を組み合わせました。',
                    price: '販売価格：800円（税込）',
                    showTitle: true,
                    showSubtitle: false,
                    link: ''
                },
                {
                    title: '日本酒',
                    subtitle: '',
                    description: '本イベントのアイコン・だるまにちなんだ純米酒『ダルマ正宗』。幻の米とも呼ばれている岐阜県特産の「ハツシモ」で造られた豊かな旨みが特徴の甘口純米。',
                    price: '販売価格：900円（税込）',
                    showTitle: true,
                    showSubtitle: false,
                    link: ''
                },
            ],
        },
    },
    en: {
        foods: {
            heading: 'FOODS',
            description: 'Enjoy a selection of themed menus curated by the NAKED, INC. food and beverage team! Offered are classic Japanese festival treats such as candy apples and yakisoba noodles, shaved ice with Japanese flavors such as matcha or yuzu, and a variety of refreshing beverages such as draft beer and highballs!',
            readMore: 'Show more',
            close: 'Close',
            external: '公式サイト',
            items: [
                {
                    title: 'Shaved Ice: Kyoto Matcha',
                    subtitle: '',
                    description: 'Kyoto shaved ice topped with homemade matcha syrup, made using luxurious green tea from renowned Kyoto tea shop Fukujuen. Enjoy the aromas of the matcha balanced with the subtle flavors of the sugar beet sweetener.Served with a daruma monaka topping exclusive to this event!',
                    price: 'Price: 900 JPY (tax included)',
                    showTitle: true,
                    showSubtitle: false,
                    link: ''
                },
                {
                    title: 'Shaved Ice: Yuzu Citrus',
                    subtitle: '',
                    description: 'A refreshing Japanese-style shaved ice topped with domestically produced yuzu. The homemade syrup also incorporates various organically grown "misshapen" citrus fruits from Kumamoto Prefecture in an initiative to reduce food loss.Served with a daruma monaka topping exclusive to this event!',
                    price: 'Price: 900 JPY (tax included)',
                    showTitle: true,
                    showSubtitle: false,
                    link: ''
                },
                {
                    title: 'Shaved Ice: Strawberry',
                    subtitle: '',
                    description: 'This thick strawberry sauce using plenty of real fruit utilizes "misshapen" strawberries from Kumamoto Prefecture in an intiative to reduce food loss.Served with a daruma monaka topping exclusive to this event!',
                    price: 'Price: 900 JPY (tax included)',
                    showTitle: true,
                    showSubtitle: false,
                    link: ''
                },
                {
                    title: 'Vegan Condensed Milk Syrup',
                    subtitle: '',
                    description: 'This original vegan condensed milk is comprised of a soy base, agave syrup, coconut milk, almond milk, rice and malt sweetener, and sugar beet. As sweet as the original, this vegan alternative is both good for your body and the environment! ',
                    price: 'Price: +150 JPY (tax included)',
                    showTitle: true,
                    showSubtitle: false,
                    link: ''
                },
                {
                    title: 'Daruma Candy Apple',
                    subtitle: '',
                    description: 'A classic summer festival sweet wrapped in an event-exclusive daruma package. Enjoy the crispy candy coating and the sweetness of the fresh apple spread in your mouth!',
                    price: 'Price: 700 JPY (tax included)',
                    showTitle: true,
                    showSubtitle: false,
                    link: ''
                },
                {
                    title: 'Takoyaki Skewers',
                    subtitle: '',
                    description: 'A classic Japanese street food of round balls of savory batter with pieces of octopus, served on a skewer.',
                    price: 'Price: 600 JPY (tax included)',
                    showTitle: true,
                    showSubtitle: false,
                    link: ''
                },
                {
                    title: 'Frankfurt Sausage',
                    subtitle: '',
                    description: 'A classic Japanese festival treat of a frankfurt sausage on a skewer.',
                    price: 'Price: 500 JPY (tax included)',
                    showTitle: true,
                    showSubtitle: false,
                    link: ''
                },
                {
                    title: 'Yuzu Lemonade Soda',
                    subtitle: '',
                    description: 'A Japanese-style homemade lemonade soda uses a citrus syrup of organic Kumamoto lemons, Ishikawa yuzu, and a hint of plum. The sweet and tart flavors and refreshing soda makes for the perfect drink for the hot summer!',
                    price: 'Price: 700 JPY (tax included)',
                    showTitle: true,
                    showSubtitle: false,
                    link: ''
                },
                {
                    title: 'Yuzu Highball',
                    subtitle: '',
                    description: 'A classic highball with a Japanese twist, flavored with a citrus syrup of organic Kumamoto lemons, Ishikawa yuzu, and a hint of plum. The tartness of the homemade syrup is the perfect summer combo with the whiskey base.',
                    price: 'Price: 800 JPY (tax included)',
                    showTitle: true,
                    showSubtitle: false,
                    link: ''
                },
                {
                    title: 'Yuzu Sour',
                    subtitle: '',
                    description: 'A Japanese-style yuzu lemon sour made with a citrusy syrup of yuzu from Ishikawa Prefecture and organic lemons from Kumamoto Prefecture, as well as a hint of Japanese plum. The tangy acidity is the the perfect base paired with the citrus aromas of the shochu "Nanakubo Blue."',
                    price: 'Price: 800 JPY (tax included)',
                    showTitle: true,
                    showSubtitle: false,
                    link: ''
                },
                {
                    title: 'Sake',
                    subtitle: '',
                    description: 'Introducing the junmai sake "Daruma Masamune," named after the iconic daruma of this event. This sweet junmai sake is made from Hatsushimo, a specialty rice of Gifu Prefecture, and is characterized by its rich umami flavor.',
                    price: 'Price: 900 JPY (tax included)',
                    showTitle: true,
                    showSubtitle: false,
                    link: ''
                },
            ],
        },
    },
    zhTW: {
        foods: {
            heading: 'FOODS',
            description: '由NAKED的飲食團隊精心策劃的夏日祭典美食，無論大人還是小孩都能盡情享受。包括經典的蘋果糖和炒麵，以及使用京都老字號茶舖「福壽園」的抹茶和國產柚子製作的日式刨冰，還有各種生啤酒和高球等酒精飲料！',
            readMore: '查看更多',
            close: '閉じる',
            external: '公式サイト',
            items: [
                {
                    title: '刨冰 京抹茶',
                    subtitle: '',
                    description: '使用京都老字號茶舖「福壽園」的高級抹茶，和精心製作的自製抹茶糖漿。抹茶的濃郁香氣與甜菜糖的溫潤甜味在口中綻放，帶來無與倫比的味覺享受。我們將附贈本次活動限定甜點達摩最中。',
                    price: '販售價格：900日元（含稅）',
                    showTitle: true,
                    showSubtitle: false,
                    link: ''
                },
                {
                    title: '柚子柑橘刨冰',
                    subtitle: '',
                    description: '使用國產柚子的清爽和風刨冰。自製糖漿還使用了多種有機栽培、販賣規格外的熊本縣產柑橘類水果，既美味又有助於解決食物浪費問題，是一款有利於可持續生態的刨冰。我們將附贈本次活動限定甜點達摩最中。',
                    price: '販售價格：900日元（含稅）',
                    showTitle: true,
                    showSubtitle: false,
                    link: ''
                },
                {
                    title: '刨冰 草莓',
                    subtitle: '',
                    description: '深受孩子們喜愛的草莓糖漿，每口都充滿大顆果肉的美味。選用熊本縣特產的販賣規格外草莓，不僅味道鮮美，還有助於減少食物浪費。我們將附贈本次活動限定甜點達摩最中。',
                    price: '販售價格：900日元（含稅）',
                    showTitle: true,
                    showSubtitle: false,
                    link: ''
                },
                {
                    title: '純素煉乳糖漿',
                    subtitle: '',
                    description: '以豆漿為基礎，並加入龍舌蘭糖漿、椰奶、杏仁奶、米糖漿和甜菜糖，打造出的純素特製練乳。不僅對身體和環境友好，其甜度和美味更與真正的練乳無異。',
                    price: '販售價格：+150日元（含稅）',
                    showTitle: true,
                    showSubtitle: false,
                    link: ''
                },
                {
                    title: '達摩蘋果糖',
                    subtitle: '',
                    description: '本次活動限定達摩包裝的夏日節慶必備美食蘋果糖。糖衣外脆內嫩，搭配新鮮蘋果的甜美在口中蔓延。',
                    price: '販售價格：700日元（含稅）',
                    showTitle: true,
                    showSubtitle: false,
                    link: ''
                },
                {
                    title: '章魚燒串',
                    subtitle: '',
                    description: '夏日祭典中不可缺少的經典美食章魚燒。串式方便單手也能輕鬆享用。',
                    price: '販售價格：600日元（含稅）',
                    showTitle: true,
                    showSubtitle: false,
                    link: ''
                },
                {
                    title: '法蘭克福香腸',
                    subtitle: '',
                    description: '夏祭典中不可缺少的經典美食法蘭克福香腸。串式方便單手也能輕鬆享用。',
                    price: '販售價格：500日元（含稅）',
                    showTitle: true,
                    showSubtitle: false,
                    link: ''
                },
                {
                    title: '柚子檸檬汽水',
                    subtitle: '',
                    description: '使用了熊本縣產的有機檸檬和石川縣產的柚子製作的糖漿，加入了隱秘的梅子調味，展現出經典日本風味的自製檸檬蘇打，口感溫和甜酸，氣泡清爽，絕對是夏日裡不可錯過的飲品選擇。',
                    price: '販售價格：700日元（含稅）',
                    showTitle: true,
                    showSubtitle: false,
                    link: ''
                },
                {
                    title: '柚子高球',
                    subtitle: '',
                    description: '使用了熊本縣產的有機檸檬和石川縣產的柚子製作的糖漿，加入了隱藏的梅子調味，帶來了經典日本風味的高球。精心調配的自製糖漿，帶來清新宜人的酸味，與威士忌完美融合。',
                    price: '販售價格：800日元（含稅）',
                    showTitle: true,
                    showSubtitle: false,
                    link: ''
                },
                {
                    title: '國產柚子檸檬沙瓦',
                    subtitle: '',
                    description: '精選石川縣產的柚子和熊本縣產的有機檸檬，調製出獨特糖漿，再巧妙融合隱秘調味的梅子，打造出濃濃日本風情的柚子檸檬沙瓦。自製糖漿的清爽酸味，與柑橘香氣四溢的芋燒酒“NANAKUBO Blue”相得益彰，帶給您前所未有的極致體驗。',
                    price: '販售價格：800日元（含稅）',
                    showTitle: true,
                    showSubtitle: false,
                    link: ''
                },
                {
                    title: '日本酒',
                    subtitle: '',
                    description: '以本次活動的圖標達摩為靈感的純米酒“達摩正宗”，採用岐阜縣特產、被譽為幻之米的“初霜”釀造，擁有豐富且獨特的甘甜口感。',
                    price: '販售價格：900日元（含稅）',
                    showTitle: true,
                    showSubtitle: false,
                    link: ''
                },
            ],
        },
    },
    zhCN: {
        foods: {
            heading: 'FOODS',
            description: '由NAKED的饮食团队精心策划的夏日祭典美食，无论大人还是小孩都能尽情享受。包括经典的苹果糖和炒面，以及使用京都老字号茶铺「福寿园」的抹茶和国产柚子制作的日式刨冰，还有各种生啤酒和高球等酒精饮料！',
            readMore: '查看更多',
            close: '閉じる',
            external: '公式サイト',
            items: [
                {
                    title: '刨冰 京抹茶',
                    subtitle: '',
                    description: '使用京都老字号茶铺「福寿园」的高级抹茶，和精心制作的自制抹茶糖浆。抹茶的浓郁香气与甜菜糖的温润甜味在口中绽放，带來无与伦比的味觉享受。我们将附赠本次活动限定甜点达摩最中。',
                    price: '售价：900日元（含税）',
                    showTitle: true,
                    showSubtitle: false,
                    link: ''
                },
                {
                    title: '柚子柑橘刨冰',
                    subtitle: '',
                    description: '使用国产柚子的清爽和风刨冰。自制糖浆还使用了多种有机栽培、销售规格外的熊本县产柑橘类水果，既美味又有助于解决食物浪费问题，是一款有利于可持续生态的刨冰。我们将附赠本次活动限定甜点达摩最中。',
                    price: '售价：900日元（含税）',
                    showTitle: true,
                    showSubtitle: false,
                    link: ''
                },
                {
                    title: '刨冰 草莓',
                    subtitle: '',
                    description: '深受孩子们喜爱的草莓糖浆，每口都充满大颗果肉的美味。选用熊本县特产的销售规格外草莓，不仅味道鲜美，还有助于减少食物浪费。我们将附赠本次活动限定甜点达摩最中。',
                    price: '售价：900日元（含税）',
                    showTitle: true,
                    showSubtitle: false,
                    link: ''
                },
                {
                    title: '纯素炼乳糖浆',
                    subtitle: '',
                    description: '以豆浆为基础，并加入龙舌兰糖浆、椰奶、杏仁奶、米糖浆和甜菜糖，打造出的纯素特制炼乳。不仅对身体和环境友好，其甜度和美味与真正的炼乳无异。',
                    price: '售价：+150日元（含税）',
                    showTitle: true,
                    showSubtitle: false,
                    link: ''
                },
                {
                    title: '达摩苹果糖',
                    subtitle: '',
                    description: '本次活动限定达摩包装的夏日几点必备美食苹果糖。糖衣外脆内嫩，搭配新鲜苹果的甜美在口中蔓延。',
                    price: '售价：700日元（含税）',
                    showTitle: true,
                    showSubtitle: false,
                    link: ''
                },
                {
                    title: '章鱼烧串',
                    subtitle: '',
                    description: '夏日祭典中不可缺少的经典美食章鱼烧。串式方便单手也能轻松享用。',
                    price: '售价：600日元（含税）',
                    showTitle: true,
                    showSubtitle: false,
                    link: ''
                },
                {
                    title: '法兰克福香肠',
                    subtitle: '',
                    description: '夏祭典中不可缺少的经典美食法兰克福香肠。串式方便单手也能轻松享用。',
                    price: '售价：500日元（含税）',
                    showTitle: true,
                    showSubtitle: false,
                    link: ''
                },
                {
                    title: '柚子柠檬汽水',
                    subtitle: '',
                    description: '使用了熊本县产的有机柠檬和石川县产的柚子制作的糖浆，加入了隐秘的梅子调味，展现出经典日本风味的自制柠檬苏打，口感温和甜酸，气泡清爽，绝对是夏日里不可错过的饮品选择。',
                    price: '售价：700日元（含税）',
                    showTitle: true,
                    showSubtitle: false,
                    link: ''
                },
                {
                    title: '柚子高球',
                    subtitle: '',
                    description: '使用了熊本县产的有机柠檬和石川县产的柚子制作的糖浆，加入了隐秘的梅子调味，带来了经典日本风味的高球。精心调配的自制糖浆，带来清新宜人的酸味，与威士忌完美融合。',
                    price: '售价：800日元（含税）',
                    showTitle: true,
                    showSubtitle: false,
                    link: ''
                },
                {
                    title: '国产柚子柠檬沙瓦',
                    subtitle: '',
                    description: '精选石川县产的柚子和熊本县产的有机柠檬，调制出独特糖浆，再巧妙融合隐秘调味的梅子，打造出浓浓日本风情的柚子柠檬沙瓦。自制糖浆的清爽酸味，与柑橘香气四溢的芋烧酒“NANAKUBO Blue”相得益彰，带给您前所未有的极致体验。',
                    price: '售价：800日元（含税）',
                    showTitle: true,
                    showSubtitle: false,
                    link: ''
                },
                {
                    title: '日本酒',
                    subtitle: '',
                    description: '以本次活动的图标达摩为灵感的纯米酒“达摩正宗”，采用岐阜县特产、被誉为幻之米的“初霜”酿造，拥有丰富且独特的甘甜口感。',
                    price: '售价：900日元（含税）',
                    showTitle: true,
                    showSubtitle: false,
                    link: ''
                },
            ],
        },
    },
    ko: {
        foods: {
            heading: 'FOODS',
            description: '네이키드의 푸드팀이 프로듀스한 아이들도 어른들도 즐길 수 있는 여름 축제 음식들을 라인업. 사과 사탕과 야키소바, 교토의 전통 찻집 「후쿠주엔」 의 말차와 국산 유자를 아낌없이 사용한 일본 특유의 식재료를 즐길 수 있는 일본풍 빙수, 생맥주와 하이볼 같은 알코올 음료도 충실하게 준비!',
            readMore: '더 알아보기',
            close: '閉じる',
            external: '公式サイト',
            items: [
                {
                    title: '빙수 교토 말차',
                    subtitle: '',
                    description: '교토의 전통 찻집「후쿠주엔」의 고급 말차를 아낌없이 사용한 수제 말차 시럽을 뿌린 교토식 빙수. 말차의 향기와 첨채당의 부드러운 단맛이 입안에 퍼집니다.본 이벤트 한정 다루마 모나카를 함께 제공합니다.',
                    price: '판매 가격: 900엔(세금 포함)',
                    showTitle: true,
                    showSubtitle: false,
                    link: ''
                },
                {
                    title: '빙수 유자 시트러스',
                    subtitle: '',
                    description: '국산 유자를 사용한 산뜻한 일본식 빙수. 수제 시럽에는 유기농으로 재배된 규격외의 구마모토현산 감귤류도 여러 종류 사용. 음식물 쓰레기 문제 해결에도 도움이 되는 지속 가능한 빙수.본 이벤트 한정 다루마 모나카를 함께 제공합니다.',
                    price: '판매 가격: 900엔(세금 포함)',
                    showTitle: true,
                    showSubtitle: false,
                    link: ''
                },
                {
                    title: '빙수 딸기',
                    subtitle: '',
                    description: '아이들에게도 인기 만점인 과육이 듬뿍 들어간 딸기 시럽. 구마모토현산의 규격외 딸기를 활용해, 음식물 쓰레기 문제 해결에도 도움이 됩니다.본 이벤트 한정 다루마 모나카를 함께 제공합니다.',
                    price: '판매 가격: 900엔(세금 포함)',
                    showTitle: true,
                    showSubtitle: false,
                    link: ''
                },
                {
                    title: '비건 연유 시럽',
                    subtitle: '',
                    description: '두유를 베이스로 아가베 시럽, 코코넛 밀크, 아몬드 밀크, 쌀 엿, 첨채당을 사용한 비건 오리지널 연유. 몸에도 환경에도 친화적이며, 진짜 연유와 다름없는 단맛과 맛을 자랑합니다.',
                    price: '판매 가격: +150엔(세금 포함)',
                    showTitle: true,
                    showSubtitle: false,
                    link: ''
                },
                {
                    title: '다루마 사과 사탕',
                    subtitle: '',
                    description: '본 이벤트 한정 다루마 패키지로 포장된 여름 축제의 정통 디저트인 사과 사탕. 캔디 코팅의 바삭한 식감과 신선한 사과의 달콤함이 입안 가득 퍼집니다.',
                    price: '판매 가격: 700엔(세금 포함)',
                    showTitle: true,
                    showSubtitle: false,
                    link: ''
                },

                {
                    title: '타코야키 꼬치',
                    subtitle: '',
                    description: '여름 축제에 빠질 수 없는 정통 먹거리인 타코야키. 한 손으로도 먹기 쉬운 꼬치 타입.',
                    price: '판매 가격: 600엔(세금 포함)',
                    showTitle: true,
                    showSubtitle: false,
                    link: ''
                },
                {
                    title: '프랑크푸르트 소시지',
                    subtitle: '',
                    description: '여름 축제에 빠질 수 없는 정통 먹거리인 프랑크푸르트 소시지. 한 손으로도 먹기 쉬운 꼬치 타입.',
                    price: '판매 가격: 500엔(세금 포함)',
                    showTitle: true,
                    showSubtitle: false,
                    link: ''
                },
                {
                    title: '유자 레모네이드 소다',
                    subtitle: '',
                    description: '구마모토현산 유기농 레몬, 이시카와현산 유자를 사용한 시럽에 비밀 재료인 매실을 블렌드한 일본다움을 느낄 수 있는 수제 레모네이드 소다. 부드러운 새콤달콤함과 톡 쏘는 탄산이 여름에 딱 맞는 음료입니다.',
                    price: '판매 가격: 700엔(세금 포함)',
                    showTitle: true,
                    showSubtitle: false,
                    link: ''
                },
                {
                    title: '유자 하이볼',
                    subtitle: '',
                    description: '구마모토현산 유기농 레몬, 이시카와현산 유자를 사용한 시럽에 비밀 재료인 매실을 블렌드한 일본다움을 느낄 수 있는 하이볼. 수제 시럽의 산뜻한 산미와 위스키가 환상의 조합입니다.',
                    price: '판매 가격: 800엔(세금 포함)',
                    showTitle: true,
                    showSubtitle: false,
                    link: ''
                },
                {
                    title: '유자 사워',
                    subtitle: '',
                    description: '이시카와현의 유자와 구마모토현의 유기농 레몬을 사용한 시럽에 비법 재료 매실을 블렌딩한 일본스러움을 느낄 수 있는 유자 레몬 사워. 직접 만든 시럽의 상큼한 산미에 잘 어울리는 감귤 향 고구마 소주 \'나나쿠보 블루\'를 조합했습니다.',
                    price: '판매 가격: 800엔(세금 포함)',
                    showTitle: true,
                    showSubtitle: false,
                    link: ''
                },
                {
                    title: '일본주',
                    subtitle: '',
                    description: '본 이벤트의 아이콘인 다루마와 연관된 순수 쌀로만 빚은 청주『다루마 마사무네』. 환상의 쌀이라 불리는 기후현 특산「하쓰시모」로 빚은 풍부한 감칠맛이 특징인 달콤한 청주.',
                    price: '판매 가격:900엔(세금 포함)',
                    showTitle: true,
                    showSubtitle: false,
                    link: ''
                },
            ],
        },
    },
}